import CONFIG from "../../utils/config"

const RolePlayCardView = ({roleplayData, showForReview, setFormData, isReviewPage}) => {

    const renderButton = (roleplayData) => {
        if (roleplayData.showView) {
            return (
              <button
              className="btn-primary reviewbtn rpsubmitbtn"
                onClick={() => showForReview(roleplayData.id)}
              >
                View
              </button>
            )
        } else if (roleplayData.showSubmit) {
            return (
              <button
                className="btn-primary reviewbtn rpsubmitbtn"
                onClick={() => setFormData(roleplayData.id, "update")}
              >
                Submit
              </button>
            )
        } else if (roleplayData.showReview) {
            return (
                <button
                  className="btn-primary reviewbtn rpsubmitbtn"
                  onClick={() => showForReview(roleplayData.id)}
                >
                  Review
                </button>
            )
        }
    }

    return (
        <>
            <div class="col-xl-4 col-md-6 brstr">
                <div class="gridviewroleplaybox">
                    <h5 
                        className="blohheadmain w-90"
                        title={roleplayData.title}
                    >
                        {roleplayData.title}
                    </h5>
                    {
                        roleplayData.isVideo ?
                        <i className="x-video-icon micxicon"></i>
                        : <i className="x-mic-icon micxicon"></i>
                    }
                    <div class="row">
                        {/* <div className="col-md-6">
                            <p class="blockhearole">Category</p>
                            <p class="blockdescrole">Training</p>
                        </div> */}
                        <div className="col-md-6">
                            <p class="blockhearole">Date Of Submission</p>
                            <p class="blockdescrole">{roleplayData.submittedDate}</p>
                        </div>
                        <div className="col-md-6">
                            <p class="blockhearole">{isReviewPage ? 'Submitted By' : 'Submitted To'}</p>
                            {
                                roleplayData.name != '-' 
                                ? 
                                <div className="usernamewimg">
                                    <img class="userimgrolefg" 
                                    src={roleplayData.avatar ? roleplayData.avatar : CONFIG.DEFAULT_AVATAR}
                                    // src="images/get_certified01.jpg"
                                    alt=""
                                    />
                                    {roleplayData.name}
                                </div>
                                : '-'
                            }
                        </div>
                        <div className="col-md-6">
                            <p class="blockhearole">{isReviewPage ? 'Feedback On' : 'Feedback Received On'}</p>
                            <p class="blockdescrole">{roleplayData.reviewedDate}</p>
                        </div>
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            {roleplayData.status}
                            {/* <span class="frdone">Feedback Received</span> */}
                            {/* <span class="pfrpending">Pending For Review</span> */}
                        </div>
                        <div className="col-md-6 btnsecrb">
                            {/* <button className="btn-primary reviewbtn rpsubmitbtn">Submit</button> */}
                            {renderButton(roleplayData)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RolePlayCardView;